import { get } from 'mobx';
import { ShowHelp } from '../field/enum';
export function defaultAggregationRenderer({ text }) {
    return text;
}
export const ColumnDefaultProps = {
    hidden: false,
    lock: false,
    resizable: true,
    sortable: false,
    hideable: true,
    aggregationLimit: 4,
    showHelp: ShowHelp.tooltip,
};
const Column = function Column() {
    return null;
};
Column.__PRO_TABLE_COLUMN = true;
Column.defaultProps = ColumnDefaultProps;
export default Column;
export function minColumnWidth(col, store) {
    const hidden = get(col, 'hidden');
    if (hidden) {
        return 0;
    }
    const width = get(col, 'width');
    const min = get(col, 'minWidth');
    const aggregation = get(col, 'aggregation');
    const minWidth = min === undefined ? store.getConfig(aggregation ? 'tableAggregationColumnDefaultMinWidth' : 'tableColumnDefaultMinWidth') : min;
    if (width === undefined) {
        return minWidth;
    }
    return Math.min(width, minWidth);
}
function getDefaultWidth(col, store, aggregation) {
    const defaultWidth = get(col, 'defaultWidth');
    if (defaultWidth === undefined) {
        return store.getConfig(aggregation ? 'tableAggregationColumnDefaultWidth' : 'tableColumnDefaultWidth');
    }
    return defaultWidth;
}
function getMinWidth(col, store, aggregation) {
    const minWidth = get(col, 'minWidth');
    if (minWidth === undefined) {
        return store.getConfig(aggregation ? 'tableAggregationColumnDefaultMinWidth' : 'tableColumnDefaultMinWidth');
    }
    return minWidth;
}
export function columnWidth(col, store) {
    const hidden = get(col, 'hidden');
    if (hidden) {
        return 0;
    }
    const width = get(col, 'width');
    if (width === undefined) {
        const aggregation = get(col, 'aggregation');
        const defaultWidth = getDefaultWidth(col, store, aggregation);
        const minWidth = getMinWidth(col, store, aggregation);
        return Math.max(minWidth, defaultWidth);
    }
    return width;
}
